import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const SuccessMessage = (props) => {
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       // Optionally call a function to close the alert or perform another action
//       // For example, you could pass an `onClose` prop to handle it
//       if (props.onClose) props.onClose();
//     }, 3000); // Automatically close after 3 seconds

//     return () => clearTimeout(timer);
//   }, [props]);

  return (
    <>
      <svg style={{ display: "none" }}>
        <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </symbol>
      </svg>

      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "10px",
          width: "25%",
          zIndex: "9999",
        }}
      >
        <div
          className="alert alert-success d-flex align-items-center"
          role="alert"
          style={{ marginBottom: "10px" }}
        >
          <svg
            className="bi flex-shrink-0 me-2"
            width="24"
            height="24"
            role="img"
            aria-label="Success:"
          >
            <use href="#check-circle-fill" />
          </svg>
          &nbsp;
          <div>{props.message}</div>
          <button 
            type="button" 
            className="btn-close" 
            onClick={props.onClose} // Close button
            aria-label="Close"
            style={{ marginLeft: 'auto' }}
          ></button>
        </div>
      </div>
    </>
  );
};

// Prop types for better validation
// SuccessMessage.propTypes = {
//   message: PropTypes.string.isRequired,
//   onClose: PropTypes.func,
// };

export default SuccessMessage;
